import React from 'react';

const highlightPartOfString = (query, suggestionListTerms, i) => {
  var _query$toLowerCase;

  const sanitizedTerm = query == null ? void 0 : (_query$toLowerCase = query.toLowerCase()) == null ? void 0 : _query$toLowerCase.trim();
  const termIndex = suggestionListTerms.toLowerCase().indexOf(sanitizedTerm);

  if (termIndex === 0) {
    return /*#__PURE__*/React.createElement("span", {
      key: i
    }, sanitizedTerm, /*#__PURE__*/React.createElement("strong", null, suggestionListTerms.substring(termIndex + sanitizedTerm.length, suggestionListTerms.length)));
  }

  return /*#__PURE__*/React.createElement("span", {
    key: i
  }, /*#__PURE__*/React.createElement("strong", null, suggestionListTerms.substring(0, termIndex)), sanitizedTerm, /*#__PURE__*/React.createElement("strong", null, suggestionListTerms.substring(termIndex + sanitizedTerm.length, suggestionListTerms.length)));
};

export default highlightPartOfString;